<div style="position: relative">
    <!-- External URL Process -->
    <a
        *ngIf="process.ProcessUrl"
        [href]="process.ProcessUrl"
        [target]="process.target ?? '_self'"
        rel="noopener"
        class="process-link-container"
    >
        <div
            *ngIf="!process.ImageOnly"
            class="process-item process-container p-button-raised w-full"
            [title]="process.ProcessDesc"
            [ngClass]="{ 
                'process-disabled': this.disabled || process.disabled,
                'process-with-image': process.ProcessResourceImage 
            }"
        >
            <div class="process-content">
                {{ process.ProcessTitle }}
            </div>
            <!-- Process Resource Image -->
            <img 
                *ngIf="process.ProcessResourceImage" 
                [src]="process.ProcessResourceImage" 
                class="process-resource-image"
                alt="Process Icon"
            />
            <!-- Message Count Badge with Bell Icon -->
            <div class="msg-count-badge" *ngIf="process.MsgCount">
                <i class="pi pi-bell" style="font-size: 0.8rem; margin-right: 4px;"></i>
                <span>{{ process.MsgCount }}</span>
            </div>
        </div>
    </a>

    <!-- Internal Route Process -->
    <div *ngIf="!process.ProcessUrl" class="process-container-wrapper">
        <div
            *ngIf="!process.ImageOnly"
            class="process-item process-container p-button-raised w-full"
            (click)="goto(process)"
            [title]="process.ProcessDesc"
            [ngClass]="{ 
                'process-disabled': this.disabled || process.disabled,
                'process-with-image': process.ProcessResourceImage 
            }"
            [style.cursor]="(this.disabled || process.disabled) ? 'not-allowed' : 'pointer'"
        >
            <div class="process-content">
                {{ process.ProcessTitle }}
            </div>
            <!-- Process Resource Image -->
            <img 
                *ngIf="process.ProcessResourceImage" 
                [src]="process.ProcessResourceImage" 
                class="process-resource-image"
                alt="Process Icon"
            />
            <!-- Message Count Badge with Bell Icon -->
            <div class="msg-count-badge" *ngIf="process.MsgCount">
                <i class="pi pi-bell" style="font-size: 0.8rem; margin-right: 4px;"></i>
                <span>{{ process.MsgCount }}</span>
            </div>
            <!-- Navigation Icon -->
            <!-- <div class="nav-icon">
                <i class="pi pi-window-maximize" style="font-size: 0.8rem;"></i>
            </div> -->
        </div>
    </div>
</div>

<!-- matBadge="{{this.process.MsgCount}}" matBadgeColor="warn" [matBadgeHidden]="this.disabled" -->
